import style from "./about.module.css"

function About() {
    return (
        <div className={style.container}>
            <h1>Hello 👋 my name is Billy</h1>
            <p>I'm Full Stack Developer with training in Front end, Back end and Databases. I've always been passionate about web development and I love to study new technologies.</p>
            <p>With ability to work individually and in team, problem solving, taking into account the analysis of the same to find solutions and executing the most suitable, committed, persistent, goal oriented, always open to keep learning constantly.</p>
            <p>You can contact me by email at oscarald.mc@gmail.com or +591 74089941</p>
            <p><a href="https://www.linkedin.com/in/billy-mendieta-cabrera/" target="_blank" rel="noreferrer">https://www.linkedin.com/in/billy-mendieta-cabrera/</a></p>
            
        </div>
    )
}

export default About